import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import axios from "../../axios/axios-football";
import * as actions from "../../store/actions/index";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import OpenMapContainer from "../../components/UI/Map/OpenMapContainer";
import Spinner from "../../components/UI/Spinner/Spinner";

const UserActivityMap = props => {
  const { onFetchSpaceStation, userActivity } = props;
  const [markerPosition, setMarkerPosition] = useState({
    lat: -25.75,
    lng: 28.33
  });

  useEffect(() => {
    onFetchSpaceStation();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      onFetchSpaceStation();
      if (props.spaceStationInformation.latitude) {
        setMarkerPosition({
          lat: props.spaceStationInformation.latitude,
          lng: props.spaceStationInformation.longitude
        });
      } else {
        setMarkerPosition({
          lat: -25.75,
          lng: 28.33
        });
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [markerPosition]);

  let mapContainer = <Spinner />;
  if (userActivity.length > 0) {
    mapContainer = (
      <OpenMapContainer
        markerPosition={markerPosition}
        userActivityPositions={userActivity}
      />
    );
  }

  return <div>{mapContainer}</div>;
};

const mapStateToProps = state => {
  return {
    userActivity: state.football.userActivity,
    spaceStationInformation: state.nasa.spaceStationInformation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchSpaceStation: () => dispatch(actions.fetchSpaceStation())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(UserActivityMap, axios));

// n2yo api QR5KEC-B8T657-392L9X-47EM
// https://www.n2yo.com/rest/v1/satellite/tle/43922&apiKey=QR5KEC-B8T657-392L9X-47EM
// https://www.n2yo.com/satellite/?s=43922
// https://www.celestrak.com/NORAD/elements/active.txt
